//
// Slam Stop Button

slamStopButton = {};

slamStopButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  button._flags.reelsSpinning = false;
  button._flags.reelsSlammed = false;
  button._flags.spinEventReceived = false;
  button._flags.anticipationSpin = false;
  button._flags.turboOn = false;

  button.canEnable = function () {
    if (button._flags.allowSlamStop) {
      return (
        this._flags.reelsSpinning &&
        !this._flags.reelsSlammed &&
        !this._flags.modal.active &&
        !this._flags.anticipationSpin &&
        !this._flags.turboOn
      );
    } else {
      // Removed slam stop due GC limitations Sept 2020.
      return false;
    }
  };

  button.canShow = function () {
    if (button._flags.allowSlamStop) {
      return this._flags.reelsSpinning && !this._flags.turboOn;
    } else {
      // Removed slam stop due GC limitations Sept 2020.
      return false;
    }
  };

  button.onPressedCallback = function () {
    this._flags.reelsSlammed = true;

    if (this._flags.spinEventReceived === true) {
      this._flags.spinEventReceived = false;
      gameController.doSlamStop();
    }

    if (button.soundName !== "") button.playSound();
  };
  button.reelSpinStarted = function (spinTask) {
    this._flags.spinEventReceived = true;
    this._flags.anticipationSpin = false;
    if (this._flags.reelsSlammed === true) {
      gameController.doSlamStop();
    }
  };
  button.reelSpinEnded = function () {
    this._flags.reelsSpinning = false;
    this._flags.reelsSlammed = false;
    this._flags.spinEventReceived = false;
    this._flags.anticipationSpin = false;
  };
  button.gameCommitted = function () {
    this._flags.reelsSpinning = true;
    this._flags.reelsSlammed = false;
  };

  button.onAnticipationSpin = function () {
    this._flags.anticipationSpin = true;
  };

  button.onTurboCurrentTurboState = function (msg) {
    this._flags.turboOn = msg.turboOn;
  };

  messageBus.subscribe(
    "spinner:SpinEvent",
    button.reelSpinStarted.bind(button)
  );
  messageBus.subscribe(
    "spinner:SpinEventDead",
    button.reelSpinEnded.bind(button)
  );
  messageBus.subscribe(
    "common:GameCommitted",
    button.gameCommitted.bind(button)
  );
  messageBus.subscribe("common:AbortGame", button.reelSpinEnded.bind(button));
  messageBus.subscribe(
    "spinner:AnticipationSpin",
    button.onAnticipationSpin.bind(button)
  );
  messageBus.subscribe(
    "common:GameCompleteEvent",
    button.reelSpinEnded.bind(button)
  );
  messageBus.subscribe(
    "turbo:currentTurboState",
    button.onTurboCurrentTurboState.bind(button)
  );

  return button;
};

slamStopButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
slamStopButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "slamStopButton",
  slamStopButton.create,
  slamStopButton.initialise,
  slamStopButton.getFilesRequired
);
